import React, { useEffect, useRef } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import FilterSectionFromToSubmit from './FilterSectionFromToSubmit';
import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import dayjs from 'dayjs';
import LeftSectionWrapper from './LeftSectionWrapper';
/* import RightSectionWrapper from './RightSectionWrapper';
import GraphSections from './GraphSections'; */
import { useDispatch } from 'react-redux';
import { getManagementDashboard } from '../../../redux/features/dashboardSlice';

const TopManagementLanding = () => {
  const storedData = localStorage.getItem('intervalManagementDashboard');
  const parsedStoredData = storedData ? JSON.parse(storedData) : {};
  const [fromDate, setFromDate] = useState(parsedStoredData?.fromDate || dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(parsedStoredData?.toDate || dayjs().endOf('month').format('YYYY-MM-DD'));
  /*   const [selectedDepartment, setSelectedDepartment] = useState(
    parsedStoredData?.selectedDepartment || { id: -1, value: 'All' },
  ) */ const dispatch = useDispatch();
  // const dispatchRef = useRef(null);
  /*   const submitFunction = () => {
    const params = {
      startDate: fromDate,
      endDate: toDate,
      deptID: selectedDepartment?.id === -1 ? '' : selectedDepartment?.id,
    };
    // Abort previous request if exists
    dispatchRef.current?.abort();

    // Dispatch new request
    const signal = dispatch(getManagementDashboard(params));
    dispatchRef.current = signal;

    const localSavingStrucuture = {
      fromDate: fromDate,
      toDate: toDate,
      selectedDepartment: selectedDepartment,
    };
    localStorage.setItem('intervalManagementDashboard', JSON.stringify(localSavingStrucuture));
  }; */

  useEffect(() => {
    const params = {
      startDate: fromDate,
      endDate: toDate,
    };

    // Dispatch new request
    const signal = dispatch(getManagementDashboard(params));
    const localSavingStrucuture = {
      fromDate: fromDate,
      toDate: toDate,
      // selectedDepartment: selectedDepartment,
    };
    localStorage.setItem('intervalManagementDashboard', JSON.stringify(localSavingStrucuture));

    return () => {
      signal.abort();
    };
  }, [fromDate, toDate, dispatch]);

  /*   const handleClearFilter = () => {
    setFromDate(dayjs().format('YYYY-MM-DD'));
    setToDate(dayjs().format('YYYY-MM-DD'));
    // setSelectedDepartment({ id: -1, value: 'All' });
    localStorage.removeItem('intervalManagementDashboard');
    // submitFunction();
  } */
  return (
    <GlobalWrapper title={'Interval Management Dashboard'}>
      {/* Filter Section */}
      <Box mb={2}>
        <FilterSectionFromToSubmit
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          // selectedDepartment={selectedDepartment}
          // setSelectedDepartment={setSelectedDepartment}
          // submitFunction={submitFunction}
          // handleClearFilter={handleClearFilter}
        />
      </Box>

      {/* Main Layout */}
      <Box width="100%">
        <Grid container spacing={2}>
          {/* Left Section */}
          <Grid item xs={12}>
            <LeftSectionWrapper fromDate={fromDate} toDate={toDate} />
          </Grid>

          {/* Right Section */}
          {/*  <Grid item xs={12} md={4}>
            <RightSectionWrapper />
          </Grid> */}
        </Grid>
      </Box>
      {/* <Box width="100%" mt={2}>
        <GraphSections />
      </Box> */}
    </GlobalWrapper>
  );
};

export default TopManagementLanding;
